import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Status, Movement, Rule, Transition, TransitionResult } from '../models/MovementModel';

export default class MovementApi {
    private http: HTTPClient;
    private rootPath: string;
    private sitiInfoPath: string;

    constructor(http: HTTPClient, rootPath: string, sitiInfoPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.sitiInfoPath = sitiInfoPath;
    }

    async getStatusList(agreement_type_id: number): Promise<Status[]> {
        const res = await this.http.get(`${this.rootPath}/agreements/dictionary/agreement_types/${agreement_type_id}/statuslist`);
        return res.data;
    }

    // API that returns the movements that can be carried out in the agreement. Movements necessary to make him change state
    async getAgreementMovements(agreement_id: number): Promise<Movement[]> {
        const res = await this.http.get(`${this.rootPath}/agreements/agreements/${agreement_id}/movements`);
        return res.data.records as Movement[];
    }

    //API that returns the checks to be carried out for the single rule
    async getRule(rule_id: number): Promise<Rule> {
        const res = await this.http.get(`/sitiInfoRestApi/api_basic/v1/applications/rules/${rule_id}`);
        return res.data;
    }

    //API that save transition from a state to another
    async saveTransition(agreement_id: number, workflow_id: number): Promise<TransitionResult> {
        const url = `${this.rootPath}/agreements/agreements/${agreement_id}/movements/${workflow_id}`
        const res = await this.http.post(url);
        return res.data;
    }

    //check rule
    async getRuleResult(agreement_id: number, movement_id: number): Promise<Rule> {
        const res = await this.http.get(`${this.rootPath}/agreements/rules_log/${agreement_id}|${movement_id}`);
        return res.data as Rule;
    }
    //chiamata per presentare l'esito della regola
    //sitiagri-rest-api/api_sso/v1/agreements/rules_log/<agreement_id>|<movement_id>




}
